import React, { Component } from 'react';
import './Header/Header.css';
import './Main/Main.css';
//import Header from './Header/Header.js';
import Main from './Main/Main.js';
import Auth from './Main/Auth.js';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

/*
  Colors are generated from
  https://material-ui.com/style/color/
  Using the Android app colors as main for primary and secondary colors
*/
const theme = createMuiTheme({
  /*
  palette: {
    primary: {
      light: '#7bb8bb',
      main: '#5ba7ab',
      dark: '#3f7477',
      contrastText: '#fff',
    },
    secondary: {
      light: '#e0985b',
      main: '#d97f33',
      dark: '#975823',
      contrastText: '#fff',
    },
  },
  */
  palette: {
    primary: {
      light: '#e0985b',
      main: '#d97f33',
      dark: '#975823',
      contrastText: '#fff',
    },
    secondary: {
      light: '#7bb8bb',
      main: '#5ba7ab',
      dark: '#3f7477',
      contrastText: '#fff',
    },
  },
});

class App extends Component {
  render() {
    console.log("Version: 1.0.11");
    const queryString = require('query-string');
    const parsed = queryString.parse(window.location.search);
    console.log("Query: " + JSON.stringify(parsed));

    {/*
      Important!
      Using paths like /auth/ might not work after the app is deployed:
      https://stackoverflow.com/questions/52749823/react-router-dom-build-giving-404-when-accessing-url-directly-but-not-in-develo

      http://localhost:3000/auth/ might work
      https://account.sikomliving.com/auth/ might give 404

      To fix this, the .htaccess script has been added to the public folder.
      https://gist.github.com/alexsasharegan/173878f9d67055bfef63449fa7136042
    
    */}
    const pathname = window.location.pathname;
    const split = pathname.split('/');
    const authString = split[1];
    let auth = false;
    if (authString === "auth") {
      auth = true;
    }

    return (
      <MuiThemeProvider theme={theme}>
        {/*
        <Header/>
      */}
        {
          auth ? <Auth
            clientId={parsed.client_id}
            redirectUri={parsed.redirect_uri}
            state={parsed.state} />
            :
            <Main
              language={parsed.language}
              initialValueCode={parsed.valueCode}
              paymentStatus={parsed.paymentStatus}
              hasMultipleGateways={parsed.hasMultipleGateways}
              shouldRenewSubscription={parsed.shouldRenewSubscription} />
        }

      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js